import React, { useMemo } from 'react';
import { MultiBarGraph } from '../../components/MultiBarGraph';
import { MultiLineGraph } from '../../components/MultiLineGraph';
import './styles.scss';
import { HomeProps } from './types';

const Home = ({cumulativeData, cumulativeByToken}: HomeProps) => {
    const multiBarDates = useMemo(() => {
        return cumulativeData.map(x => x.DATE);
    }, [cumulativeData]);

    const cumulativeValues = useMemo(() => {
        return {
            'Cumulative USD': cumulativeData.map(x => x.CUMULATIVE_MEV_AMOUNT_USD)
        };
    }, [cumulativeData]);

    const cumulativeByTokenValues = useMemo(() => {
        if(!multiBarDates || multiBarDates.length === 0) {
            return {};
        }

        let values: {
            [token: string]: number[];
        } = {};

        let counts: {
            [token: string]: number;
        } = {};

        for(const value of cumulativeByToken) {
            if(!values[value.SYMBOL]) {
                values[value.SYMBOL] = [];
                counts[value.SYMBOL] = 0;
            }
            values[value.SYMBOL].push(value.CUMULATIVE_MEV_AMOUNT_USD);
            counts[value.SYMBOL]++;
        }

        //add padding
        for(const [symbol, count] of Object.entries(counts)) {
            let padding = multiBarDates.length - count;
            for(var i = 0; i < padding; i++) {
                values[symbol].unshift(0);
            }
        }

        return values;
    }, [multiBarDates, cumulativeByToken]);

    const dailyValues = useMemo(() => {
        return {
            'Daily USD': cumulativeData.map(x => x.MEV_AMOUNT_USD)
        };
    }, [cumulativeData]);

    return (
        <div className="home-page">
            <MultiBarGraph 
                title='Cumulative USD Extracted'
                dates={multiBarDates}
                data={cumulativeValues}
            />
            <MultiLineGraph 
                title='Cumulative USD Extracted By Token'
                dates={multiBarDates}
                data={cumulativeByTokenValues}
            />
            <MultiBarGraph 
                title='Daily USD Extracted'
                dates={multiBarDates}
                data={dailyValues}
            />
        </div>
    );
}

export default Home;